export const educationData = [
    {
        id: 1,
        institution: 'NIET, Greater Noida',
        course: 'B.Tech (Computer Science)',
        startYear: '2015',
        endYear: '2019'
    }
]